export default __webpack_public_path__ + "static/media/Animation 1.368ae7a2.mp4";